import loggingService from '../util/loggingService'
import _ from 'lodash/lodash.min.js'
import dateService from '../../services/util/dateService'

var serviceName = 'evaluationService'
var path = '/EvaluationInstance/'
var isDebug = false

function put (http, evaluation) {
    loggingService.log(isDebug, serviceName, 'put')
    return http.put(path, evaluation)
}

function get (http, id) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'Get?evaluationId=' + id)
}

function search (http, searchObject) {
    loggingService.log(isDebug, serviceName, 'search by ' + searchObject.culturalResourceRecordingId)
    return http.post(path + 'Search', searchObject)
}

function currentEligibility (http, culturalResourceId) {
    loggingService.log(isDebug, serviceName, 'get')
    return http.get(path + 'CurrentEvaluation?culturalResourceId=' + culturalResourceId)
}

function historicEligibility (http, culturalResourceId) {
    loggingService.log(isDebug, serviceName, 'get historic')
    return http.get(path + 'HistoricEvaluationX?culturalResourceId=' + culturalResourceId).then(response => {
        if (response.data) {
            response.data.forEach(x => {
                x.completeDate = dateService.convertToDate(x.completeDate)
            })
        }
        return response
    })
}

function saveProduction (http, evaluation) {
    loggingService.log(isDebug, serviceName, 'saveProduction')
    return http.put(path + 'SaveProduction', evaluation)
}

function getEligibilityCriteriaList () {
    return [
        {eligibilityTypeId: 1, description: 'A'},
        {eligibilityTypeId: 2, description: 'B'},
        {eligibilityTypeId: 3, description: 'C'},
        {eligibilityTypeId: 4, description: 'D'}
    ]
}

function sourceName (evaluationSourceId) {
    var name = _.invert(EvaluationSourceEnum)[evaluationSourceId]
    loggingService.log(isDebug, serviceName, `id ${evaluationSourceId} maps to ${name}`)
    return name
}

const EligibilityEnum = {
    Eligible: 1,
    NotEligible: 2,
    Unevaluated: 3
}

const EvaluationSourceEnum = {
    Consultant: 1,
    Agency: 2,
    SHPO: 3,
    Current: 4
}

const ConcurredEnum = {
    ShpoConcurred: 1,
    AgencyDetermination: 2,
    ConsultantRecommend: 3
}

const EligibilityTypeList = [
    { eligibilityId: 1, description: 'Eligible' },
    { eligibilityId: 2, description: 'Not Eligible' },
    { eligibilityId: 3, description: 'Unevaluated' }
]

const EffectList = [
    { effectId: 1, description: 'No Effect' },
    { effectId: 2, description: 'No Adverse Effect' },
    { effectId: 3, description: 'Adverse Effect' },
    { effectId: 6, description: 'Not Applicable' }
]

const ConcurredList = [
    { concurredId: 1, description: 'SHPO Concurred' },
    { concurredId: 2, description: 'Agency Determination' },
    { concurredId: 3, description: 'Consultant Recommendation' },
    { concurredId: 4, description: 'No Concurrence' }
]

const UndertakingEffectList = [
    { effectId: 1, description: 'No Effect' },
    { effectId: 2, description: 'No Adverse Effect' },
    { effectId: 3, description: 'Adverse Effect' },
    { effectId: 4, description: 'Exempt' },
    { effectId: 5, description: 'No Historic Properties Affected' }
]

export default {
    put: put,
    get: get,
    search: search,
    saveProduction: saveProduction,
    getEligibilityCriteriaList: getEligibilityCriteriaList,
    currentEligibility: currentEligibility,
    historicEligibility: historicEligibility,
    sourceName: sourceName,
    EvaluationSourceEnum: EvaluationSourceEnum,
    EligibilityEnum: EligibilityEnum,
    EligibilityTypeList: EligibilityTypeList,
    EffectList: EffectList,
    ConcurredList: ConcurredList,
    UndertakingEffectList: UndertakingEffectList,
    ConcurredEnum: ConcurredEnum
}



// WEBPACK FOOTER //
// ./src/services/siteForm/evaluationService.js